module.exports = __webpack_public_path__ + "d80163b80eecec7be10381f245971c8d.jpg";